import styled from '@emotion/styled';
import { useCompanySwitcher } from './useCompanySwitcher';

const Wrapper = styled.div`
    position: relative;
`;

const Trigger = styled.button`
    cursor: pointer;
    padding: 8px 18px;
    border: none;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 700;
    color: var(--white);
    background-color: var(--dark-blue);
    display: flex;
    align-items: center;
    gap: 8px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
    transition: opacity 0.15s ease-in;

    &:hover {
        opacity: 0.85;
    }
`;

const Caret = styled.span`
    font-size: 10px;
    opacity: 0.8;
`;

const Menu = styled.ul`
    position: absolute;
    top: calc(100% + 4px);
    right: 0;
    background: var(--white);
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    list-style: none;
    margin: 0;
    padding: 4px 0;
    min-width: 220px;
    z-index: 100;
`;

const MenuItem = styled.li<{ isCurrent: boolean }>`
    padding: 8px 14px;
    font-size: 14px;
    cursor: pointer;
    font-weight: ${(p) => (p.isCurrent ? 700 : 400)};
    background: ${(p) => (p.isCurrent ? '#f0f4ff' : 'transparent')};
    &:hover {
        background: #f5f5f5;
    }
`;

const Overlay = styled.div`
    position: fixed;
    inset: 0;
    z-index: 99;
`;

// 「{企業ラベル} 企業名」表記。企業名が空の場合は「企業名未設定」
const membershipDisplayName = (m: { company_name: string | null; company_label: string | null }) =>
    `${m.company_label ?? ''} ${m.company_name || '企業名未設定'}`.trim();

export const CompanySwitcher: React.FC = () => {
    const { memberships, current, open, setOpen, loading, onSwitch } = useCompanySwitcher();

    if (memberships.length < 2) return null;

    return (
        <Wrapper>
            <Trigger type="button" onClick={() => !loading && setOpen(!open)}>
                企業切り替え
                <Caret>▼</Caret>
            </Trigger>
            {open && (
                <>
                    <Overlay onClick={() => setOpen(false)} />
                    <Menu>
                        {memberships.map((m) => (
                            <MenuItem
                                key={m.company_id}
                                isCurrent={m.company_id === current?.company_id}
                                onClick={() => onSwitch(m.company_id)}
                            >
                                {membershipDisplayName(m)}
                            </MenuItem>
                        ))}
                    </Menu>
                </>
            )}
        </Wrapper>
    );
};
